module.exports = __webpack_public_path__ + "static/media/B_S03.5fd8867f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_S03.png
// module id = 68
// module chunks = 0